import { render, staticRenderFns } from "./ThreadsContainer.vue?vue&type=template&id=171c1656&scoped=true&"
import script from "./ThreadsContainer.vue?vue&type=script&lang=js&"
export * from "./ThreadsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ThreadsContainer.vue?vue&type=style&index=0&id=171c1656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c1656",
  null
  
)

export default component.exports